import azure from '../images/azure.svg';

const techs = [
	{
		src: 'https://img.icons8.com/ios-filled/250/c-sharp-logo.png',
		alt: 'C#',
		label: 'C# / .NET',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/unity.png',
		alt: 'Unity',
		label: 'Unity',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/javascript.png',
		alt: 'JavaScript',
		label: 'JavaScript',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/python.png',
		alt: 'Python',
		label: 'Python',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/react-native--v1.png',
		alt: 'React',
		label: 'React',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/windows/128/vuejs.png',
		alt: 'Vue',
		label: 'VueJS',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios/150/java-coffee-cup-logo--v1.png',
		alt: 'Java',
		label: 'Java',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/adobe-logo.png',
		alt: 'Adobe',
		label: 'Adobe Suite',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/150/ableton.png',
		alt: 'Ableton',
		label: 'Ableton',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/external-tal-revivo-light-tal-revivo/150/external-autodesk-an-american-multinational-software-corporation-for-the-architecture-and-other-engineering-services-logo-light-tal-revivo.png',
		alt: 'Autodesk',
		label: 'Maya 3D',
		invert: true,
	},
	{
		src: 'https://img.icons8.com/ios-filled/50/roblox-studio.png',
		alt: 'Roblox Studio',
		label: 'Roblox Studio',
		invert: true,
	},
	{ src: azure, alt: 'Azure', label: 'Azure', dim: true, invert: true },
];

export default function Technologies() {
	return (
		<div className="tech-grid">
			{techs.map(({ src, alt, label, invert, dim }, i) => (
				<div key={i} className="tech-item">
					<img
						src={src}
						alt={alt}
						style={{
							filter: invert
								? 'invert(1) brightness(0.7)'
								: dim
									? 'brightness(0.65)'
									: undefined,
						}}
					/>
					<span>{label}</span>
				</div>
			))}
		</div>
	);
}
